<!-- <div style="background-color: rgb(8, 8, 178); height: 100vh; color: white; padding-top: 4vh;">
    <div class="d-flex justify-content-center align-items-center" style="border-bottom: 0.2vh solid white; padding-bottom: 1vh;">            
        <img src="../../../../../assets/images/logo-cangio-bg.png" alt="" style="width: 10vh;">                    
        <div style="font-size: 4vh; font-weight: bold; padding-left: 10vw;">
            ỦY BAN NHÂN DÂN <br/> &nbsp;&nbsp;&nbsp;HUYỆN CẦN GIỜ
        </div>        
    </div>
    <div class="p-5 d-flex justify-content-center title-z">        
        {{dateString}}
    </div>
    <div class="d-flex justify-content-center" style="padding-left: 5%; padding-right: 5%; padding-top: 2vh;">
        <table class="table table-bordered">
            <thead>
                <tr>                    
                    <td style="width: 10%;" class="text-center text-white">GIỜ</td>
                    <td class="text-center text-white">NỘI DUNG</td>
                    <td class="text-center text-white" style="width: 10%;">CHỦ TRÌ</td>
                    <td style="width: 20%;" class="text-center text-white">ĐỊA ĐIỂM</td>
                </tr>
            </thead>            
            <tr *ngFor="let item of scheduleArr">                    
                <td class="text-white text-center">{{item.scheduleTime}}</td>
                <td class="text-white text-center">{{item.scheduleTitle}}</td>
                <td class="text-white text-center">{{item.officerName}}</td>
                <td class="text-white text-center">{{item.otherLocation}}</td>
            </tr>                            
        </table>
    </div>
</div> -->

<div style="height: 100vh;padding-top: 1vh; color: rgb(23, 5, 95); font-weight: bold; font-family: 'Times New Roman', Times, serif;">
    <div class="d-flex justify-content-center align-items-center"
        style="border-bottom: 0.4vh solid rgb(23, 5, 95); padding-bottom: 1vh;">
        <img src="../../../../../assets/images/logo-cangio-bg.png" alt="" style="width: 14vh;">
        <div style="font-size: 5vh; font-weight: bold; padding-right: 10vw; padding-left: 10vw;">
            ỦY BAN NHÂN DÂN HUYỆN CẦN GIỜ
        </div>        
    </div>
    <div class="p-5 d-flex justify-content-center title-z">
        <!-- <h1>LỊCH HỌP NGÀY {{today | date: 'dd-MM-yyyy' }}</h1> -->
        {{dateString}}
    </div>
    <div class="d-flex justify-content-center" style="padding-left: 5%; padding-right: 5%; padding-top: 2vh;">
        <div style="width: 100%; height: 100%;">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <td style="width: 10vw;" class="text-center">GIỜ</td>
                        <td class="text-center">NỘI DUNG</td>
                        <td class="text-center" style="width: 15vw;">CHỦ TRÌ</td>
                        <td style="width: 15vw;" class="text-center">ĐỊA ĐIỂM</td>
                    </tr>
                </thead>                
            </table>
            <table style="border: none;">
                <tr style="border: none;">
                    <td style="border: none;" class="table-container">
                        <div class="marquee" style="--itemCount: {{scheduleArr.length}}">
                            <table>
                                <tr style="height: 5vh;">
                                    <td style="width: 10vw;" class="text-center"></td>
                                    <td class="text-center"></td>
                                    <td style="width: 15vw;" class="text-center"></td>
                                    <td style="width: 15vw;" class="text-center"></td>
                                </tr>
                                <tr *ngFor="let item of scheduleArr">
                                    <td style="width: 10vw; color: rgb(202, 1, 1);" class="text-center">{{item.scheduleTime}}</td>
                                    <td class="text-center">{{item.scheduleTitle}}</td>
                                    <td style="width: 15vw; color: rgb(0, 0, 181);" class="text-center">{{item.officerName}}</td>
                                    <td style="width: 15vw;" class="text-center">{{item.otherLocation}}</td>
                                </tr>                                
                            </table>
                        </div>
                    </td>
                </tr>
            </table>
            
        </div>   
              
    </div>
</div>